import { defaultTo, flow, head, mapValues, split } from 'es-toolkit/compat';

import { localeData } from '../../features/translations/localeData';

const DEFAULT_LOCALE = 'en-GB';
const supportedLocaleMap = mapValues(localeData, (value, key) => key);

const extractLanguage = flow(
    locale => defaultTo(locale, DEFAULT_LOCALE),
    locale => split(locale, '-'),
    head
);

const DEFAULT_LANG = extractLanguage(DEFAULT_LOCALE);

export { DEFAULT_LANG, DEFAULT_LOCALE, extractLanguage, supportedLocaleMap };
